import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import FiberNetwork from './pages/FiberNetwork';
import TelecomTowers from './pages/TelecomTowers';
import InternetSolutions from './pages/InternetSolutions';
import DataCenters from './pages/DataCenters';
import ManagedServices from './pages/ManagedServices';
import EnterpriseSolutions from './pages/EnterpriseSolutions';
import Coverage from './pages/Coverage';
import Projects from './pages/Projects';
import Partners from './pages/Partners';
import Sustainability from './pages/Sustainability';
import Careers from './pages/Careers';
import News from './pages/News';
import FAQs from './pages/FAQs';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flexGrow: 1, mt: '80px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/fiber-network" element={<FiberNetwork />} />
          <Route path="/services/telecom-towers" element={<TelecomTowers />} />
          <Route path="/services/internet-solutions" element={<InternetSolutions />} />
          <Route path="/services/data-centers" element={<DataCenters />} />
          <Route path="/services/managed-services" element={<ManagedServices />} />
          <Route path="/services/enterprise-solutions" element={<EnterpriseSolutions />} />
          <Route path="/coverage" element={<Coverage />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/news" element={<News />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
}

export default App;